/**
 * This module contains utilities used for converting Relax NG files to the
 * format required by salve.
 *
 * @author Louis-Dominique Dubeau
 * @license MPL 2.0
 * @copyright Mangalam Research Center for Buddhist Languages
 *
 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var convert_1 = require("./conversion/convert");
exports.convertRNGToPattern = convert_1.convertRNGToPattern;
var parser_1 = require("./conversion/parser");
exports.Element = parser_1.Element;
exports.Node = parser_1.Node;
exports.parseSimplifiedSchema = parser_1.parseSimplifiedSchema;
exports.Text = parser_1.Text;
var resource_loader_1 = require("./conversion/resource-loader");
exports.makeResourceLoader = resource_loader_1.makeResourceLoader;
var serializer_1 = require("./conversion/serializer");
exports.serialize = serializer_1.serialize;
var schema_simplification_1 = require("./conversion/schema-simplification");
exports.getAvailableSimplifiers = schema_simplification_1.getAvailableSimplifiers;
exports.makeSimplifier = schema_simplification_1.makeSimplifier;
var schema_validation_1 = require("./conversion/schema-validation");
exports.getAvailableValidators = schema_validation_1.getAvailableValidators;
exports.makeValidator = schema_validation_1.makeValidator;
exports.SchemaValidationError = schema_validation_1.SchemaValidationError;
//# sourceMappingURL=conversion.js.map